import * as types from './actionTypes';
import {ajaxCallError} from './ajaxStatusActions';
import {Api} from '../api/Api';
import {beginAjaxCall, sinReducerSuccess} from './ajaxStatusActions';




export function getInscripcionListSuccess(inscripcion) {
  return {type: types.LOAD_INSCRIPCION_LIST_SUCCESS, inscripcion};
}


/*
export function getInscripcionList(pagina, regitrosPorPagina, filtro, showActivos, filtrosCombo, token) {
    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().InscripcionApi.getInscripcionList(pagina, regitrosPorPagina, filtro, showActivos, filtrosCombo, token).then(inscripcion => { 
                  //console.log("Action");
                  dispatch(getInscripcionListSuccess(inscripcion));
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}
*/

export function getInscripcionList(id,filtro,  token) {
    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().InscripcionApi.getInscripcionList(id,filtro, token).then(inscripcion => { 
                  dispatch(getInscripcionListSuccess(inscripcion));
                  return(inscripcion)
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}

export function getReporteInscripcion(id,filtro,token) {
    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().InscripcionApi.getReporteInscripcion(id,filtro, token).then(inscripcion => { 
                  dispatch(getInscripcionListSuccess(inscripcion));
                  return(inscripcion)
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}





export function getInscripcionByUsuarioList(correo, token) {
    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().InscripcionApi.getInscripcionByUsuarioList(correo, token).then(inscripcion => { 
                  dispatch(sinReducerSuccess());
                  return(inscripcion)
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}


export function getInscripcionPagoList(id, token) {
    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().InscripcionApi.getInscripcionPagoList(id, token).then(inscripcion => { 
                  dispatch(getInscripcionListSuccess(inscripcion));
                  return(inscripcion)
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}


export function getReportePagos(id, token) {
    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().InscripcionApi.getReportePagos(id, token).then(inscripcion => { 
                  dispatch(getInscripcionListSuccess(inscripcion));
                  return(inscripcion)
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}


export function getInscripcionSuccess(catalogo) {
  return {type: types.LOAD_INSCRIPCION_SUCCESS, catalogo};
}

export function getInscripcion(id, token) {
    return dispatch => {
        dispatch(beginAjaxCall());  
        return Api().InscripcionApi.getInscripcion(id, token).then(inscripcion => {   
        dispatch(getInscripcionSuccess(inscripcion));
        return inscripcion;
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}




export function saveSuccess(inscripcion) {
  return {type: types.SAVE_INSCRIPCION_SUCCESS, inscripcion};
}



export function cambiarEstatus(id, token) {
    
  return dispatch => {
	dispatch(beginAjaxCall());  
    return Api().InscripcionApi.cambiarEstatus(id, token).then(inscripcionGuardado => {   
    dispatch(sinReducerSuccess());
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}


export function cambiarEstatusExamen(id, idCurso, token) {
    
  return dispatch => {
	dispatch(beginAjaxCall());  
    return Api().InscripcionApi.cambiarEstatusExamen(id, idCurso,token).then(inscripcionGuardado => {   
    dispatch(sinReducerSuccess());
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}


export function save(inscripcion, token) {
    
  return dispatch => {
	dispatch(beginAjaxCall());  
    return Api().InscripcionApi.save(inscripcion, token).then(inscripcionGuardado => {   
    dispatch(saveSuccess(inscripcionGuardado));
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}


export function constanciasSuccess(inscripcion) {
  return {type: types.CONSTANCIAS_INSCRIPCION_SUCCESS, inscripcion};
}


export function constancias(token) {
    
  return dispatch => {
	dispatch(beginAjaxCall());  
    return Api().InscripcionApi.constancias(token).then(constancias => {   
    dispatch(constanciasSuccess(constancias));
        return constancias;
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}


export function getConstancias(cursoId, token) {
    
  return dispatch => {
	dispatch(beginAjaxCall());  
    return Api().InscripcionApi.getConstancias(cursoId,token).then(constancias => {   
    dispatch(constanciasSuccess(constancias));
        return constancias;
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}




export function getInscripcionComboSuccess(datos) {
  return {type: types.GET_INSCRIPCIONS_COMBO_SUCCESS, datos};
}

export function getInscripcionCombo(token) {
    
  return dispatch => {
     
	dispatch(beginAjaxCall());  
      
    return Api().InscripcionApi.getInscripcionCombo(token).then(datos => {   
        
      dispatch(getInscripcionComboSuccess(datos));
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}



export function getInscripcionUsuariosCombo(idCurso, token) {
    
  return dispatch => {
     
	dispatch(beginAjaxCall());  
      
    return Api().InscripcionApi.getInscripcionUsuariosCombo(idCurso,token).then(datos => {   
        
      dispatch(getInscripcionComboSuccess(datos));
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}

export function borrarSuccess(inscripcion) {
  return {type: types.BORRAR_INSCRIPCION_SUCCESS, inscripcion};
}


export function borrar(id, token ) {    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().InscripcionApi.borrar(id, token ).then(inscripcion => {
               
                  dispatch(borrarSuccess(inscripcion));
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}


export function borrarPermanente(id, token ) {    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().InscripcionApi.borrarPermanente(id, token ).then(inscripcion => {
               
                  dispatch(sinReducerSuccess());
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}




export function activarSuccess(inscripcion) {
  return {type: types.ACTIVAR_INSCRIPCION_SUCCESS, inscripcion};
}


export function activar(id, token) {    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().InscripcionApi.activar(id, token).then(inscripcion => {
               
                  dispatch(activarSuccess(inscripcion));
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}


export function constanciaSuccess(inscripcion) {
  return {type: types.CONSTANCIA_INSCRIPCION_SUCCESS, inscripcion};
}


export function constancia(inscripcionId, token) {    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().InscripcionApi.constancia(inscripcionId, token).then(inscripcion => {
               
                  dispatch(constanciaSuccess(inscripcion));
                  return inscripcion;
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}


export function setFiltro(filtroActivo, filtroActual, showActivos) {
	let filtro={
		filtroActivo,
		filtroActual,
        showActivos
	}
  return {type: types.SET_FILTRO_INSCRIPCION, filtro};
}



